import React from 'react';
import SIcon from './SIcon';
import { faDoorOpen } from '@fortawesome/pro-regular-svg-icons';

const Icon = props => <SIcon {...props} icon={faDoorOpen} fa />;

export default Icon;
